export default __webpack_public_path__ + "static/media/avt_logo.b00d2613.svg";